module.exports = __webpack_public_path__ + "img/PL08168.b09fb129.png";